export default __webpack_public_path__ + "static/media/search.aa56dbe1.svg";